module.exports = "/_next/static/images/team_logo-f74f231bc449e1234c9bdc77e10cd2c6.png";